import { type Routes } from '@angular/router';

import { routePaths } from './app-route-paths';
import { ComponentsComponent } from './components/components.component';
import { FeaturesComponent } from './features/features.component';

/** App routes. */
export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: routePaths.components.path,
  },
  {
    path: routePaths.components.path,
    component: ComponentsComponent,
    loadChildren: () => import('./components/components.routes')
      .then(r => r.COMPONENTS_ROUTES),
  },
  {
    path: routePaths.features.path,
    component: FeaturesComponent,
    loadChildren: () => import('./features/features.routes')
      .then(r => r.FEATURES_ROUTES),
  },
];
